import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@environment';
import { IToken } from '@services/api/token';
import { AuthService } from '@services/auth/auth.service';
import { NetworksService } from '@services/networks/networks.service';
import { PricesService } from '@services/prices/prices.service';
import { EVMProviderFactoryService } from '@services/provider/evm-provider-factory.service';
import { ethers } from 'ethers';

export interface ITxInfo
{
    hash: string;
    senderAddress: string;
    recipientAddress: string;
    amount: string;
    gasUsed: string;
    gasUsedUsd: string;
    confirmations: number;
    dt: number;
    state?: 0 | 1 | 2;
}

@Component({
    selector: 'app-tx-view',
    templateUrl: './tx-view.component.html',
    styleUrls: [ './tx-view.component.scss' ]
})
export class TxViewComponent
{
    public txInfo: ITxInfo;
    public scanLink: string;
    public baseCurrency: IToken;

    private authState: boolean;

    private confirmationsCount: number = 10;

    constructor(
        private route: ActivatedRoute,
        private providerFactory: EVMProviderFactoryService,
        private networkService: NetworksService,
        private priceService: PricesService,
        private auth: AuthService,
        private location: Location,
        private router: Router
    )
    {
        this.init();
        this.auth.loginState.subscribe(data => this.authState = data);
    }

    public handleBackCLick()
    {
        if (this.authState)
        {
            this.location.back();
            return;
        }

        this.router.navigate([ '/' ]);
    }

    private async init()
    {
        const txHash = this.route.snapshot.paramMap.get('hash');
        const chainId = Number(this.route.snapshot.paramMap.get('chain-id'));
        this.scanLink = environment[ chainId ].scan;
        const provider = await this.providerFactory.getProvider(chainId);
        this.baseCurrency = await this.networkService.getCoinByChainId(chainId);
        const receipt = await provider.getTransactionReceipt(txHash);
        const block = await provider.getBlock(receipt.blockHash);
        const gasUsed = Number(ethers.formatEther(receipt.gasUsed * BigInt(receipt.cumulativeGasUsed)));
        const price = await this.priceService.getPrice(this.baseCurrency.symbol, 'USD', chainId);
        const confirmations = await receipt.confirmations()

        if (confirmations < this.confirmationsCount)
        {
            this.txInfo = {
                hash: receipt.hash,
                senderAddress: receipt.from,
                recipientAddress: receipt.to,
                amount: '0',
                gasUsed: gasUsed.toString(),
                gasUsedUsd: String(gasUsed * Number(price.price)),
                confirmations: confirmations,
                dt: block.timestamp * 1000,
                state: 2,
            };

            const tx = await provider.getTransaction(txHash);
            await tx.wait(this.confirmationsCount);

            const receiptAfterWait = await provider.getTransactionReceipt(txHash);
            const gasUsedAfterWait = Number(ethers.formatEther(receiptAfterWait.gasUsed*(receiptAfterWait.cumulativeGasUsed)));

            this.txInfo = {
                hash: receiptAfterWait.hash,
                senderAddress: receiptAfterWait.from,
                recipientAddress: receiptAfterWait.to,
                amount: '0',
                gasUsed: gasUsedAfterWait.toString(),
                gasUsedUsd: String(gasUsedAfterWait * Number(price.price)),
                confirmations: confirmations,
                dt: block.timestamp * 1000,
                state: <0 | 1>receiptAfterWait.status,
            };
            return;
        }

        this.txInfo = {
            hash: receipt.hash,
            senderAddress: receipt.from,
            recipientAddress: receipt.to,
            amount: '0',
            gasUsed: gasUsed.toString(),
            gasUsedUsd: String(gasUsed * Number(price.price)),
            confirmations: confirmations,
            dt: block.timestamp * 1000,
            state: <any>receipt.status,
        };


    }
}
